// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "input[type='file']{display:none}.custom-file-upload{border:1px solid #ccc;display:inline-block;padding:6px 12px;cursor:pointer}.file-preview{margin:0 10px}\n", "",{"version":3,"sources":["StyleButtonFile.scss"],"names":[],"mappings":"AAAA,mBAAmB,YAAY,CAAC,oBAAoB,qBAAqB,CAAC,oBAAoB,CAAC,gBAAgB,CAAC,cAAc,CAAC,cAAc,aAAa","file":"StyleButtonFile.scss","sourcesContent":["input[type='file']{display:none}.custom-file-upload{border:1px solid #ccc;display:inline-block;padding:6px 12px;cursor:pointer}.file-preview{margin:0 10px}\n"]}]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--1-oneOf-2-2!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib??postcss!./src/style/StyleButtonFile.scss
// module id = 3626
// module chunks = 0